function initializeBurgerMenu() {
  const header = document.querySelector('.header');

  if (!header) {
    return null;
  }

  const headerNav = header.querySelector('.header__nav');
  const headerBurgerButton = header.querySelector('.header__burger');

  if (!headerNav || !headerBurgerButton) {
    return null;
  }

  const htmlElement = document.documentElement;
  const ACTIVE_CLASS = 'open-burger';
  const SCROLL_LOCK_CLASS = 'no-scroll';

  function toggleMenu() {
    headerNav.classList.toggle(ACTIVE_CLASS);
    headerBurgerButton.classList.toggle(ACTIVE_CLASS);
    htmlElement.classList.toggle(SCROLL_LOCK_CLASS);

    const isActive = headerNav.classList.contains(`${ACTIVE_CLASS}`);

    headerNav.style.height = isActive ? headerNav.scrollHeight + 'px' : '0';
  }

  headerBurgerButton.addEventListener('click', toggleMenu);
}

export default initializeBurgerMenu;